import cart from '../helpers/cart-helper'
import refs from '../helpers/refs'

class CopyImage {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    if (!Array.isArray(this.$refs.addToCartButton)) {
      this.$refs.addToCartButton = [this.$refs.addToCartButton]
    }

    // Add to cart script
    this.$refs.addToCartButton.forEach((button) => {
      if (button !== undefined) {
        const innerElem = button.children.length > 0 ? button.children[0] : button
        // Look for variant-id progressively going up the heirarchy
        // Done this way to avoid grabbing main product variant ID if on product page
        const variantID = button.closest('[data-default-variant-id]').dataset.defaultVariantId

        button.addEventListener('click', (e) => {
          // Handle iOS Safari's buggy click event behavior
          e.preventDefault()
          e.stopPropagation()

          // Set text to loading
          const originalInnerText = innerElem.innerText
          innerElem.innerText = 'Adding..'
          innerElem.style.animationPlayState = 'paused'

          cart
            .addProductsToCart([
              {
                id: variantID,
                quantity: 1
              }
            ])
            .then(() => {
              // Done adding to cart state
              innerElem.innerText = 'Added to cart!'

              // Reset to initial state
              setTimeout(() => {
                innerElem.innerText = originalInnerText
                innerElem.style.animationPlayState = 'running'
              }, 3000)
            })
        })
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-copy-image]')
    .forEach(el => new CopyImage(el))
})
